// extracted by mini-css-extract-plugin
export default {"textInput":"TextInput_textInput__wPDty","placeholderError":"TextInput_placeholderError__deroU","error":"TextInput_error__pN-y7","firstInput":"TextInput_firstInput__oXzT9"};